import kinetikApi from './kinetikAPI';

export default {
  getAccessToken: () =>
    kinetikApi
      .post('/proxy/kinetik-access-token', undefined, { serviceName: 'proxy' })
      .then((res) => res.data),
  getTripEstimationLyft: (
    params,
    transportationProviderId,
    payerId,
    requesterOrgResourceId,
  ) =>
    kinetikApi
      .get(
        `/proxy/kinetik/${transportationProviderId}/${payerId}/${requesterOrgResourceId}/proxy/lyft/v1/cost`,
        {
          ...params,
          serviceName: 'proxy',
        },
      )
      .then((res) => res.data),
  getTripEstimationUber: (
    params,
    body,
    transportationProviderId,
    payerId,
    requesterOrgResourceId,
  ) =>
    kinetikApi
      .post(
        `/proxy/kinetik/${transportationProviderId}/${payerId}/${requesterOrgResourceId}/proxy/uber/v1/health/trips/estimates`,
        body,
        {
          ...params,
          serviceName: 'proxy',
        },
      )
      .then((res) => res.data),
  getDriverAvailability: (
    params,
    transportationProviderId,
    payerId,
    requesterOrgResourceId,
  ) =>
    kinetikApi
      .get(
        `/proxy/kinetik/${transportationProviderId}/${payerId}/${requesterOrgResourceId}/proxy/lyft/v1/concierge-driver-availability`,
        {
          ...params,
          serviceName: 'proxy',
        },
      )
      .then((res) => res.data),
  getMemberAppUserData: (userUuid, params) =>
    kinetikApi
      .get(`/proxy/ma/user/${userUuid}/app-data`, {
        ...params,
        serviceName: 'proxy',
      })
      .then((res) => res.data),
  inviteMemberApp: (patientUuid, params) =>
    kinetikApi
      .post(`/proxy/ma/invitation/scheduler-patient/${patientUuid}`, params, {
        serviceName: 'proxy',
      })
      .then((res) => res.data),
  getMemberAppInvitationData: (patientUuid) =>
    kinetikApi
      .get(`/proxy/ma/invitation/scheduler-patient/${patientUuid}`, {
        serviceName: 'proxy',
      })
      .then((res) => res.data),
  activateMemberApp: (userUuid, params) =>
    kinetikApi
      .patch(`/proxy/ma/user/${userUuid}/activate`, params, {
        serviceName: 'proxy',
      })
      .then((res) => res.data),
  deactivateMemberApp: (userUuid, params) =>
    kinetikApi
      .patch(`/proxy/ma/user/${userUuid}/deactivate`, params, {
        serviceName: 'proxy',
      })
      .then((res) => res.data),
  dispatchWillCallTripToLyft: (
    params,
    transportationProviderId,
    payerId,
    requesterOrgResourceId,
    bookingId,
  ) =>
    kinetikApi
      .post(
        `/proxy/kinetik/${transportationProviderId}/${payerId}/${requesterOrgResourceId}/proxy/lyft/v1/flex-requests/${bookingId}/dispatch`,
        {},
        { ...params, serviceName: 'proxy' },
      )
      .then((res) => res.data),
  dispatchWillCallTripToUber: (
    params,
    transportationProviderId,
    payerId,
    requesterOrgResourceId,
    bookingId,
  ) =>
    kinetikApi
      .post(
        `/proxy/kinetik/${transportationProviderId}/${payerId}/${requesterOrgResourceId}/proxy/uber/v1/health/trips/${bookingId}/dispatch`,
        {},
        { ...params, serviceName: 'proxy' },
      )
      .then((res) => res.data),
};
